var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.02426 3.31999C0.789949 3.08568 0.410051 3.08568 0.175736 3.31999C-0.0585787 3.55431 -0.0585787 3.93421 0.175736 4.16852L2.35362 6.3464C2.58793 6.58072 2.96783 6.58072 3.20215 6.3464L8.3576 1.19095C8.59191 0.956637 8.59191 0.576738 8.3576 0.342423C8.12328 0.108108 7.74338 0.108108 7.50907 0.342423L2.77788 5.07361L1.02426 3.31999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.2a573d526e640a3520460821d9fe2499.svg";
export { ForwardRef as ReactComponent };